// extracted by mini-css-extract-plugin
export default {"page":"ReviseOrder_page__pItou"};